import { CheckedState } from '@radix-ui/react-checkbox';
import { Checkbox } from '@swivl-mono/ui';
import React from 'react';
interface DelayComponentProps {
  hideEllipsisOption?: boolean
  node: any
  onChange(event: any): void
}

export default class DelayComponent extends React.Component<DelayComponentProps> {
  constructor(props: DelayComponentProps) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
  }

  onChange(e: any) {
    const value = e.target.value;
    if (isNaN(value)) { return; }
    if (value < 0) { return; }
    this.props.onChange(e);
  }

  onCheckboxChange(checked: CheckedState, name: string) {
    if (!this.props.node) { return; }
    let node = JSON.parse(JSON.stringify(this.props.node));
    node[name] = checked;

    this.props.onChange({ target: { name: name, value: checked } });
  }

  render() {
    if (this.props.hideEllipsisOption) {
      return <div className="delayDisplay" style={{ marginBottom: "10px" }}>
        <span className="delayHeading" style={{ lineHeight: "30px" }}>Delay</span>
        <span className="delayLabel">
          <input className="delayValueInput grey" value={this.props.node.delay} onChange={this.onChange} type="number" name="delay" /> sec.
        </span>
      </div>
    }

    return <div className="delayDisplay">
      <span className="delayHeading">Delay</span>
      <div className="delayContent">
        <Checkbox
          label="Show ellipsis"
          onCheckedChange={(checked) => this.onCheckboxChange(checked, "showTyping")}
          checked={this.props.node.showTyping}
          name="showTyping"
        />
        <span className="delayLabel">
          <input className="delayValueInput grey" value={this.props.node.delay} onChange={this.onChange} type="number" name="delay" /> sec.
        </span>
      </div></div>;
  }
};
